module.exports = __webpack_public_path__ + "img/checkbox-checked.3a0db04e.svg";